import type { BodyView } from '@ubus/shared';
import { CCI_BODY_VIEWS } from '@ubus/shared';
import { useTranslation } from 'react-i18next';

interface BodyDiagramProps {
  selected: BodyView[];
  onToggle: (view: BodyView) => void;
}

const VIEW_PATH: Record<BodyView, string> = {
  left: 'M20 70 h140 v40 h-140 z',
  right: 'M20 70 h140 v40 h-140 z',
  front: 'M40 30 h80 v100 h-80 z',
  back: 'M40 30 h80 v100 h-80 z',
};

function BodyDiagram({ selected, onToggle }: BodyDiagramProps) {
  const { t } = useTranslation();

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
      {CCI_BODY_VIEWS.map((v) => {
        const active = selected.includes(v.id);
        return (
          <button
            key={v.id}
            type="button"
            onClick={() => onToggle(v.id)}
            aria-pressed={active}
            style={{
              border: active ? '2px solid #d48806' : '1px solid #d9d9d9',
              borderRadius: 12,
              padding: 8,
              background: active ? '#fff7e6' : '#fff',
              textAlign: 'center',
            }}
          >
            <svg viewBox="0 0 180 160" width="100%" height={88} aria-hidden>
              <rect x="8" y="8" width="164" height="144" rx="10" fill="#f5f5f5" stroke="#bbb" />
              <path
                d={
                  v.id === 'front' || v.id === 'back'
                    ? 'M55 35 h70 a12 12 0 0 1 12 12 v70 h-94 v-70 a12 12 0 0 1 12-12z'
                    : 'M25 55 h130 v45 h-20 v15 h-20 v-15 h-50 v15 h-20 v-15 h-20 z'
                }
                fill={active ? '#ffe7ba' : '#e6f4ff'}
                stroke={active ? '#d48806' : '#1677ff'}
                strokeWidth="2"
              />
              <path d={VIEW_PATH[v.id]} fill="transparent" />
              {(v.id === 'left' || v.id === 'right') && (
                <>
                  <text x="30" y="50" fontSize="10" fill="#888">
                    {v.id === 'left' ? t('inspection.bodyFront') : t('inspection.bodyBack')}
                  </text>
                  <text x="120" y="50" fontSize="10" fill="#888">
                    {v.id === 'left' ? t('inspection.bodyBack') : t('inspection.bodyFront')}
                  </text>
                </>
              )}
              {(v.id === 'front' || v.id === 'back') && (
                <text x="70" y="28" fontSize="11" fill="#888">
                  {t(`inspection.bodyViews.${v.id}`).toUpperCase()}
                </text>
              )}
            </svg>
            <div style={{ fontSize: 13, fontWeight: 600, marginTop: 4 }}>
              {t(`inspection.bodyViews.${v.id}`)}
              {active ? (
                <span style={{ color: '#d48806', fontWeight: 500 }}>
                  {' '}
                  · {t('inspection.defect')}
                </span>
              ) : null}
            </div>
          </button>
        );
      })}
    </div>
  );
}

export default BodyDiagram;
